import { Helmet } from "react-helmet"
import { FormAuth } from "../../components/authForm/authForm"


export const Signup = () => {
    return (
        <>
            <Helmet>
                <title>SHOP.CO | Signup - Create Your Account</title>
                <meta
                    name="description"
                    content="Create a SHOP.CO account to start shopping, track orders, and enjoy a personalized online shopping experience."
                />

                <link
                    rel="canonical"
                    href="https://shop-co-roan.vercel.app/signup/"
                />
            </Helmet>

            <FormAuth title="Register" fields={["userName", "email", "password", "passwordC"]} endPoint="signup" buttonName="Register" />
        </>
    )
}